<template>
    <div class="agent-traderole-edit">
      <div class="section" style="min-height: 100%">
        <div class="section-title">{{$t('proxy.text229')}}</div>
        <div class="section-content mt-20">
          <el-form :model="form" label-width="auto" style="max-width: 600px">
            <el-form-item :label="$t('proxy.text230') + '：'" prop="name" required>
              <el-input v-model="form.name" placeholder="" style="width: 200px" disabled />
            </el-form-item>
            <el-form-item :label="$t('fundHistory.text9') + '：'" prop="status" required>
              <el-radio-group v-model="form.status" disabled>
                <el-radio :value="1">{{$t('proxy.text47')}}</el-radio>
                <el-radio :value="0">{{$t('proxy.text48')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('fundHistory.text48') + '：'" prop="rulesGroupLevel" required>
              <el-input v-model="form.rulesGroupLevelName" style="width: 200px" disabled />
            </el-form-item>
          </el-form>
        </div>
  
        <div class="section-title mt-30">{{$t('proxy.text228')}}</div>
        <div class="section-content mt-20">
          <div class="table-container">
            <el-table
              :data="feeList"
              header-row-class-name="data-header"
              header-cell-class-name="data-header-cell"
              style="width: 100%;"
              height="400px"
            >
              <el-table-column :label="$t('proxy.text87')" width="130">
                <template #default="scope">
                  <span>{{ scope.row.symbol || '--' }}</span>
                </template>
              </el-table-column>
  
      
  
              <!-- 返点 -->
              <el-table-column :label="$t('proxy.text304')" width="120">
                <template #default="scope">
                  <span>{{ scope.row.commission || '0' }}</span>
                </template>
              </el-table-column>

               <!-- 手续费 -->
              <el-table-column prop="tradeFee" :label="$t('deposit.text41')" width="120">
                <template #default="scope">
                    <span>{{ scope.row.tradeFee || '0' }}</span>
                </template>
              </el-table-column>

              <!-- 手续费返佣 -->
              <el-table-column :label="$t('proxy.text307')" width="120">
                <template #default="scope">
                  <span>{{ scope.row.tradeFeeCommission || '0' }}</span>
                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import apiService from '@/api/request';
  import { useI18n } from "vue-i18n";
  
  const route = useRoute();  // 用于获取路由参数
  const t = useI18n().t;
  const form = reactive({
    name: '',
    status: 1,  // 状态默认 1 为正常
    rulesGroupLevel: '', // 规则组等级
    rulesGroupLevelName: '', // 类型名称
    isTemplate: 0, // 默认是否模板为 0
    warnRate: undefined,
    closingRate: undefined,
    isFixeSpreads: 0, // 默认固定点差为 0
  });
  const feeList = ref([]); // 交易品种列表
  
  
  // 获取路由传递的groupName
  onMounted(() => {
    const rulesGroupID = route.query.rulesGroupID;  // 从路由参数中获取rulesGroupID
  
    if (rulesGroupID) {
      form.rulesGroupID = rulesGroupID;  // 如果存在rulesGroupID，则设置到form中
    }
  
    fetchRulesGroupInfo();
  });
  
  // 请求上级规则组信息并初始化表单，传入路由参数中的rulesGroupID
  const fetchRulesGroupInfo = async () => {
    const rulesGroupID = route.query.rulesGroupID || null;  // 从路由参数中获取rulesGroupID
    const parentId = route.query.parentId || null;  // 从路由参数中获取rulesGroupID
    
    try {
      // const params 如果rulesGroupName有值就意味着是编辑不是新增，传入rulesGroupID，否则就是新增，传入parentId
      const params = parentId ? { parentId } : { rulesGroupID };
      const { data } = await apiService.proxyRulesGroupInfo(params);
      Object.assign(form, data.model);
  
      form.name = data.model.rulesGroupName;
  
      form.rulesGroupLevel = data.model.rulesGroupLevel;
  
      // 根据规则组等级显示类型名称
      switch (data.model.rulesGroupLevel) {
        case 1:
          form.rulesGroupLevelName = t('proxy.text225');
          break;
        case 2:
          form.rulesGroupLevelName = t('proxy.text226');
          break;
        case 3:
          form.rulesGroupLevelName = t('proxy.text227');
          break;
        default:
          form.rulesGroupLevelName = t('proxy.text227');
      }
  
      feeList.value = data.feeList.map((item) => {
        const disposablePoints = parseFloat(item.disposablePoints) || 0;
        const commission = parseFloat(item.commission) || 0;
        const subordinateScale = disposablePoints > 0 
      ? parseFloat(((commission / disposablePoints) * 100).toFixed(2)) // 转为百分比并保留两位小数
      : '0.00';
      const disposableTradeFee = parseFloat(item.disposableTradeFee) || 0;
      const tradeFeeCommission = parseFloat(item.tradeFeeCommission) || 0;
        return {
          ...item,
          subordinatePoints: Math.max(0, disposablePoints - commission), // 剩余佣金
          subordinateScale: subordinateScale, // 返佣比例
          subordinateTradeFee: (disposableTradeFee - tradeFeeCommission).toFixed(2), // 剩余手续费
        };
      });
    
      console.log('feeList:', feeList.value);
    } catch (error) {
      console.log('获取规则组信息失败', error);
    }
  };

  
  </script>
  
  <style scoped lang="less">
  .agent-traderole-edit {
    height: 99%;
  }
  .form-footer {
    margin-top: 40px;
  }
  .table-container {
    padding: 0;
    max-height: 400px;
    overflow-y: auto;
  }
  .dialog-footer {
    padding-top: 20px;
    display: flex;
    justify-content: right;
  }
  
  </style>